// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNUSED REDUCER AND CORRECTED RESPONSE HANDLING
// MODIFIED DATE: 19-09-2025

import { docodeHexResponse } from '../../_common/common.utils';
import goldLoanCollectionActionTypes from './gold-loan-collection-report.types';

const INITIAL_STATE = {
	// Gold LoanCollection List Response
	getGoldLoanCollectionListResponse: null,
	getGoldLoanCollectionListArr: [],
};

const goldLoanCollectionReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH GOLD LOAN COLLECTION LIST DETAILS START *********************** */
		case goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_SUCCESS:
			return {
				...state,
				getGoldLoanCollectionListResponse: action.payload,
				getGoldLoanCollectionListArr: docodeHexResponse(
					action.payload,
					'GetGoldLoanCollectionReportKey',
				),
			};

		case goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_FAILURE:
			return { ...state, getGoldLoanCollectionListResponse: action.payload };

		case goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_CHANGED:
			return { ...state, getGoldLoanCollectionListResponse: null };
		/** ***************** FETCH GOLD LOAN COLLECTION LIST DETAILS END *********************** */
		default:
			return state;
	}
};

export default goldLoanCollectionReportReducer;
